import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Observable, Subscription} from 'rxjs';
import {Chart} from 'chart.js';
import { Q_GRADIMENTO } from 'src/app/model/questionnaires/questionnaire-gradimento';
@Component({
  selector: 'app-questionario-gradimento',
  templateUrl: './questionario-gradimento.component.html',
  styleUrls: ['./questionario-gradimento.component.css']
})
export class QuestionarioGradimentoComponent implements OnInit {
  
    getAuthState: Observable<any>;
    getDoctorState: Observable<any>;
    isAuthenticated: boolean;
    user = null;
    errorMessage = null;
    isHovered = false;
    subscription1: Subscription;
    subscription2: Subscription;
    subscription3: Subscription;
    dataSource = Q_GRADIMENTO;
    displayedColumns = ['position', 'question','avg_score'];
    canvas: any;
    ctx: any;
    myChartQuestionnaires: Chart;

    title = "Questionario di gradimento - risultati";
    destination = 'general-status';
    
    // ******************************************************************************************************************
    // seguenti righe: inizializzazione dei questionari
    //
    // ******************************************************************************************************************
    nums: number[] = [];
    Tot_questionnaires=0;
    Tot_suggerimenti=0;
    suggerimenti : string[] = [];
    // ******************************************************************************************************************
    // bar chart dei questionari
    // ******************************************************************************************************************
    public barChartLabelsGlobal = ['Domanda 1','Domanda 2','Domanda 3','Domanda 4','Domanda 5','Domanda 6','Domanda 7','Domanda 8','Domanda 9'];
    public barChartTypeGlobal = 'bar';
    public barChartLegendGlobal = true;
    public barChartDataGlobal = [
      {
        data: this.nums, label: 'Score medio', backgroundColor: ['teal','teal','teal','teal','teal', 'teal','teal','teal','teal'],
        hoverBackgroundColor: ['#066', '#066'], barThickness: 60,  // number (pixels) or 'flex'
      }
    ];
  
    constructor(private store: Store<AppState>,
                private doctorService: DoctorService,
                private snackBar: MatSnackBar) {
      this.getAuthState = this.store.select(selectAuthState);
      this.getDoctorState = this.store.select(selectDoctorState);
    }
    ngOnInit(): void {
      this.subscription3 = this.getAuthState.subscribe((state) => {
        this.isAuthenticated = state.isAuthenticated;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.errorMessage = state.errorMessage;
        this.retrievedata();
        this.retrieveSuggerimenti();
      });
    }
    ngOnDestroy(): void {
      this.subscription1.unsubscribe();
      this.subscription2.unsubscribe();
      this.subscription3.unsubscribe();

    }
  
    retrievedata() {
      this.subscription1 = this.doctorService.getQuestionnaireGradimentoScoreAVG().subscribe( data => {
        console.log(data);
        for (let x=0; x < Object.keys(data).length-1; x++){
          this.nums[x] = parseFloat(data[x].toFixed(2));
          } 
          this.Tot_questionnaires=parseInt(data[9]);
        this.canvasSetting();
        }, error => {
          if (error.status === 500) {
            localStorage.setItem('expirationTime', '0');
            console.log('SESSIONE SCADUTA');
            location.reload();
          }
        });
    }

    retrieveSuggerimenti() {
      this.subscription2 = this.doctorService.getQuestionnaireGradimentoSuggerimenti().subscribe( data => {
        console.log(data);
        this.Tot_suggerimenti=Object.keys(data).length;
        for (let x=0; x < Object.keys(data).length; x++){
          this.suggerimenti.push(data[x]);
          } 
          console.log(this.suggerimenti);
        }, error => {
          if (error.status === 500) {
            localStorage.setItem('expirationTime', '0');
            console.log('SESSIONE SCADUTA');
            location.reload();
          }
        });
    }

  
    canvasSetting() {
      this.canvas = document.getElementById('myChartQuestionnaireGradimento') as HTMLCanvasElement;
      this.ctx = this.canvas.getContext('2d');
      this.myChartQuestionnaires = new Chart(this.ctx, {
        type: this.barChartTypeGlobal,
        data: {
          labels: this.barChartLabelsGlobal,
          datasets: this.barChartDataGlobal,
        },
        options: {
          maintainAspectRatio: true,
          responsive: true,
          scales: {
            xAxes: [{
              display: true,
              stacked: false,
              ticks: {
                fontSize: 12,
                fontStyle: 'bold',
                fontFamily: 'Helvetica',
                fontColor: '#006192'
              }
            }],
            yAxes: [{
              display: true,
              stacked: false,
              ticks: {
                fontSize: 12,
                fontStyle: 'bold',
                fontFamily: 'Helvetica',
                fontColor: '#006192'
              }
            }],
          },
          legend: {
            display: true,
            position: 'top',
            labels: {
              usePointStyle: true,
              fontColor: '#006192',
              fontSize: 18,
              fontFamily: 'Helvetica',
            }
          },
          tooltips: {
            // content: '{pathology}: {number}',
            backgroundColor: '#1c1c1c',
            bodyFontSize: 18,
            titleFontSize: 18,
            cornerRadius: 5,
            caretPadding: 10
          },
          title: {
            display: true,
            text: 'Punteggio medio domande "Questionario di Gradimento"',
            fontColor: '#006192',
            fontSize: 20,
            fontFamily: 'Helvetica',
          },
          hover: {
            mode: 'nearest',
            intersect: true
          }
        }
      });
      }

  
  }
  